import React from "react";
import { Redirect, Route, useRouteMatch } from "react-router-dom";
import ParentWrapper from "../../components/ParentWrapper";
import PrivateRoute from "../../components/PrivateRoute";
import UserAppManager from "../../../src/pages/UserAppManager";
import AptTool from "../AptTool";

const ParentApt = (props) => {
  let { path } = useRouteMatch();
  return (
    <ParentWrapper path={path}>
      <PrivateRoute exact path={`${path}/manage`}>
        <AptTool />
      </PrivateRoute>
      {/* <PrivateRoute exact path={`${path}/users`}>
        <UserAppManager service={`${path}`} />
      </PrivateRoute> */}
      <Route>
        <Redirect to={`${path}/manage`} />
      </Route>
    </ParentWrapper>
  );
};

export default ParentApt;
